<template>
    <g
        v-if="box"
        :data-box-id="box.id"
        :id="box.id"
        :data-x="box.x"
        :data-y="box.y"
        :data-width="box.width"
        :data-height="box.height"
        :key="box.id"
        :class="{ 'box-group': boxGroupClass, selected: selected }"
        @click.stop="emitSelectedBox()"
    >
        <rect
            :class="{ box: !preview, selected: selected }"
            :x="box.x"
            :y="box.y"
            :rx="boxStyle.borderRadius"
            :ry="boxStyle.borderRadius"
            :width="box.width"
            :height="box.height"
            :stroke="boxStyle.border ? boxStyle.stroke : 'none'"
            stroke-width="0.5"
            :fill="fill"
            :style="{ resize: 'both', overflow: box.hideOverflowContent ? 'hidden' : 'visible' }"
        />
        <rect
            :class="{ resizePoint: !preview, left: !preview }"
            :x="box.absLeftResizePoint.x"
            :y="box.absLeftResizePoint.y"
            :width="box.resizePointWidth"
            :height="box.resizePointHeight"
            :fill="!preview ? '#F9B128' : 'transparent'"
            :stroke="!preview ? 'black' : 'transparent'"
            :stroke-width="!preview ? 0.5 : ''"
        />
        <rect
            :class="{ resizePoint: !preview, right: !preview }"
            :x="box.absRightResizePoint.x"
            :y="box.absRightResizePoint.y"
            :width="box.resizePointWidth"
            :height="box.resizePointHeight"
            :fill="!preview ? '#F9B128' : 'transparent'"
            :stroke="!preview ? 'black' : 'transparent'"
            :stroke-width="!preview ? 0.5 : ''"
        />
        <rect
            :class="{ resizePoint: !preview, top: !preview }"
            :x="box.absTopResizePoint.x"
            :y="box.absTopResizePoint.y"
            :width="box.resizePointWidth"
            :height="box.resizePointHeight"
            :fill="!preview ? '#F9B128' : 'transparent'"
            :stroke="!preview ? 'black' : 'transparent'"
            :stroke-width="!preview ? 0.5 : ''"
        />
        <rect
            :class="{ resizePoint: !preview, bottom: !preview }"
            :x="box.absBottomResizePoint.x"
            :y="box.absBottomResizePoint.y"
            :width="box.resizePointWidth"
            :height="box.resizePointHeight"
            :fill="!preview ? '#F9B128' : 'transparent'"
            :stroke="!preview ? 'black' : 'transparent'"
            :stroke-width="!preview ? 0.5 : ''"
        />

        <rect
            :class="{ resizePoint: !preview, topLeft: !preview }"
            :x="box.absTopLeftResizePoint.x"
            :y="box.absTopLeftResizePoint.y"
            :width="box.resizePointWidth"
            :height="box.resizePointHeight"
            :fill="!preview ? '#F9B128' : 'transparent'"
            :stroke="!preview ? 'black' : 'transparent'"
            :stroke-width="!preview ? 0.5 : ''"
        />
        <rect
            :class="{ resizePoint: !preview, topRight: !preview }"
            :x="box.absTopRightResizePoint.x"
            :y="box.absTopRightResizePoint.y"
            :width="box.resizePointWidth"
            :height="box.resizePointHeight"
            :fill="!preview ? '#F9B128' : 'transparent'"
            :stroke="!preview ? 'black' : 'transparent'"
            :stroke-width="!preview ? 0.5 : ''"
        />
        <rect
            :class="{ resizePoint: !preview, bottomLeft: !preview }"
            :x="box.absBottomLeftResizePoint.x"
            :y="box.absBottomLeftResizePoint.y"
            :width="box.resizePointWidth"
            :height="box.resizePointHeight"
            :fill="!preview ? '#F9B128' : 'transparent'"
            :stroke="!preview ? 'black' : 'transparent'"
            :stroke-width="!preview ? 0.5 : ''"
        />
        <rect
            :class="{ resizePoint: !preview, bottomRight: !preview }"
            :x="box.absBottomRightResizePoint.x"
            :y="box.absBottomRightResizePoint.y"
            :width="box.resizePointWidth"
            :height="box.resizePointHeight"
            :fill="!preview ? '#F9B128' : 'transparent'"
            :stroke="!preview ? 'black' : 'transparent'"
            :stroke-width="!preview ? 0.5 : ''"
        />

        <CustomForeignObject
            v-if="!isSVG"
            :box="box"
            type="basic"
            :preview="preview"
            :hideMenuOptions="hideMenuOptions"
        >
        </CustomForeignObject>
    </g>
</template>
<script lang="ts">
import { Box, Layout, LayoutMode, ComponentBoxModel, GridContainer, GridCell } from "./models";
import { Component, Vue, Prop, Watch, toNative } from "vue-facing-decorator";
import CompanyStatusBoard from "../CompanyStatusBoard.vue";
import CashFlowPlan from "../dashboard/CashFlowPlan.vue";
import Home from "../Home.vue";
import CustomForeignObject from "./CustomForeignObject.vue";
import CardAmount from "../CardAmount.vue";
import TextField from "./components/TextField.vue";
import DesignerService from "./designer.service";

interface MoveCoordinates {
    clientX?: number;
    clientY?: number;
}

@Component({
    components: {
        CompanyStatusBoard,
        // CardAmount,
        Home,
        CashFlowPlan,
        CustomForeignObject,
        TextField,
    },
    emits: ["selected-box", "moved-box"],
})
export class BoxComponent extends Vue {
    @Prop() box: Box;
    // @Prop({default: false}) selected: boolean
    // @Prop({default: false}) preview: boolean
    @Prop({ default: "EDITION" }) viewType: "EDITION" | "REPORT" | "PREVIEW";
    @Prop({ default: null }) hideMenuOptions: string[];

    get selected() {
        return this.box?.isSelected;
    }

    get preview() {
        return this.viewType === "PREVIEW";
    }

    get boxGroupClass() {
        return this.viewType === "EDITION" || this.viewType === "REPORT";
    }

    type = "basic";

    selectedResizePoint:
        | "left"
        | "right"
        | "top"
        | "bottom"
        | "topLeft"
        | "topRight"
        | "bottomLeft"
        | "bottomRight"
        | "box"
        | "" = "";
    movePosition: MoveCoordinates = {}; // Box position at each move step
    moveStart: MoveCoordinates = {}; // Box position before starting the move
    isMoving: boolean = false;

    movementStep = 10;

    get parentContainer(): GridContainer | Layout {
        return this.box.parentContainer;
    }

    get boxId() {
        return this.box?.id;
    }

    get isSVG() {
        return this.type === "svg";
    }

    get fill() {
        return this.boxStyle?.fill ?? "transparent";
    }

    // <CardAmount
    //     :companyId="companyId"
    //     :periods="periods"
    //     :accountingKey="'K5M7dlWgTNheYB5E_70'"
    //     :showBtnDetails="true"
    //     @onVueDetailedChanged="() => {emit = 'K5M7dlWgTNheYB5E_70'}"
    //     id="TurnoverDashboard"
    // >
    // </CardAmount>

    cardAmountTestProps = {
        accountingKey: "GMmaP08MdztHyvBH",
        showBtnDetails: true,
        id: "TurnoverDashboardd",
        companyId: "ck93umltabtuf0730wifcojfb",
        periods: [
            {
                start: "2024-01-01",
                end: "2024-12-31",
            },
        ],
        legend: false,
    };

    get generalTheme() {
        console.log("this.box?.selectedGeneralTheme", this.box?.selectedGeneralTheme);
        return this.box?.selectedGeneralTheme ?? {};
    }

    get boxStyle() {
        // console.log("this.generalTheme?.values?.boxStyle", this.generalTheme?.values?.boxStyle)
        return this.box.boxStyle; //this.generalTheme?.values?.boxStyle ?? {}
    }

    beforeMount() {
        console.log("BoxComponent", this.box);
        this.setMoveStart(this.box.x, this.box.y);
        this.initListeners();
    }

    beforeDestroy() {
        this.removeListeners();
    }

    @Watch("parentContainer.properties.nRows")
    @Watch("parentContainer.properties.nCols")
    @Watch("parentContainer.properties.matchCellWidth")
    @Watch("parentContainer.properties.matchCellHeight")
    @Watch("parentContainer.properties.overflowCell")
    @Watch("parentContainer.properties.cellPadding")
    @Watch("parentContainer.properties.childrenMatchWidth") // For SimpleContainer class
    rebuildParentContainer() {
        this.parentContainer.buildGrid(/*true*/);
    }

    initListeners() {
        this.$el.addEventListener("mousedown", (evt) => {
            const target = (evt.target as any).closest(".resizePoint");
            if (target) {
                this.onMouseDown(evt);
            }
        });

        this.$el.addEventListener("mousedown", (evt) => {
            const target = (evt.target as any).closest(".box-group");
            if (target) {
                this.onMouseDownBox(evt);
            }
        });

        this.$el.addEventListener("mouseup", this.onMouseUp);
        // this.$el.addEventListener("mousemove", this.onMouseMove)

        document.addEventListener("mouseup", this.onMouseUp);
        document.addEventListener("mousemove", this.onMouseMove);
    }

    removeListeners() {
        this.$el.removeEventListener("mouseup", this.onMouseUp);
        this.$el.removeEventListener("mousemove", this.onMouseMove);

        this.$el.removeEventListener("mousedown", null);
        document.removeEventListener("mouseup", this.onMouseUp);
        document.removeEventListener("mousemove", this.onMouseMove);
    }

    emitSelectedBox() {
        // this.box.isSelected = true
        this.$emit("selected-box", this.box);
    }

    onMouseDown(evt) {
        if (this.preview) {
            return;
        }

        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation(); // Important since an element and its parent have the same event listener
        // const parent = evt.target?.parentElement
        // const boxId = parent.dataset?.["boxId"]
        // this.selectedBoxId = boxId
        this.isMoving = true;
        const classList = [...(evt.target?.classList ?? [])];
        this.setMoveStart(this.box.x, this.box.y);
        this.setMovePosition(evt);
        this.box.updatePreviousCoordinates();
        // console.log("classList", classList)
        if (classList.includes("left")) {
            this.selectedResizePoint = "left";
        } else if (classList.includes("top")) {
            this.selectedResizePoint = "top";
        } else if (classList.includes("right")) {
            this.selectedResizePoint = "right";
        } else if (classList.includes("bottom")) {
            this.selectedResizePoint = "bottom";
        } else if (classList.includes("topLeft")) {
            this.selectedResizePoint = "topLeft";
        } else if (classList.includes("topRight")) {
            this.selectedResizePoint = "topRight";
        } else if (classList.includes("bottomLeft")) {
            this.selectedResizePoint = "bottomLeft";
        } else if (classList.includes("bottomRight")) {
            this.selectedResizePoint = "bottomRight";
        }
        // console.log("evttt", evt, "parent", parent, "boxId", this.boxId)
    }

    onMouseDownBox(evt) {
        if (this.preview) {
            return;
        }
        evt.stopImmediatePropagation();
        // this.$emit("selected-box", this.box)
        if (!this.box.editableContent) {
            evt.preventDefault();
        }
        let box = evt.target;
        if (box?.closest(".contenteditable")) {
            // Do not move in contenteditable parts
            // debugger
            return;
        }
        this.setMoveStart(this.box.x, this.box.y);
        this.setMovePosition(evt);
        this.box.updatePreviousCoordinates();
        // console.log("setMovePosition", this.movePosition)
        if (box.tagName !== "g" && ![...box.classList].includes("box-group")) {
            box = evt.target?.closest("g.box-group");
        }
        // console.log("box", box)
        if (box) {
            const boxId = box.dataset?.["boxId"];
            this.isMoving = true;
            this.selectedResizePoint = "box";
            // console.log("evtttt", evt, "boxId", boxId, "closest g", evt.target.closest("g"))
        }

        console.log("evtevt", evt, this.box);
    }

    onMouseUp(evt: MouseEvent) {
        if (this.preview) {
            return;
        }
        evt.preventDefault();
        // console.log("onMouseUp", this.selectedResizePoint)

        if (this.box && this.isMoving) {
            // const selector = ".designer-container"
            // let closestContainer: Element //= evt.target?.closest(selector)
            // if (closestContainer.id === this.box?.id) {
            //     // A box can also be container. In the case we have to go upper the tree
            //     // debugger
            //     if (closestContainer.parentElement) {
            //         closestContainer = closestContainer.parentElement?.closest(selector)
            //         console.log("if (closestContainer.parentElement) closestContainer", closestContainer)
            //     }
            // } else {
            //     // debugger
            //     console.log("closestContainer", closestContainer, "this.box.id", this.box.id)
            // }

            // const hoveredContainers = [...(document.querySelectorAll( ".designer-container:hover" ))].reverse()
            // const hoveredContainers = document.elementsFromPoint(evt.clientX, evt.clientY)  // #
            // console.log("hoveredContainers", hoveredContainers)
            // for (const containerEl of hoveredContainers) {
            //     if (![...containerEl.classList].includes("designer-container") || containerEl.id === this.boxId) {
            //         // Continue if it is not a container or the box is a a container itself
            //         continue
            //     }
            //     else {
            //         closestContainer = containerEl
            //         break
            //     }
            // }

            // console.log("closestContainer", closestContainer, "this.box.id", this.box.id)
            const initialBoxContainer: GridContainer | Layout = this.box.parentContainer;
            const containerObj: GridContainer | Layout = this.getClosestContainer(evt);
            // console.log("Box moving", evt, "this.box.parentContainer?.id", this.box.parentContainer?.id, "closestContainer", closestContainer?.id, closestContainer, "containerObj", containerObj)
            console.log(
                "containerObj?.id !== this.box.parentContainer?.id",
                containerObj?.id !== this.box.parentContainer?.id,
            );

            if (containerObj && !this.isResizing) {
                // const initialCellObj = this.box.cell  // May be null
                const closestCellObj = this.getClosestGridCell(evt, containerObj);

                // Cell should be empty
                if (containerObj.id !== this.box.parentContainer?.id && !closestCellObj?.box) {
                    // debugger
                    // console.log("offsetsWithAncestor", this.box.offsetsWithAncestor(containerObj))
                    const layoutOffsetBox = this.box.offsetWithLayout;
                    const layoutOffsetContainer = containerObj.offsetWithLayout;

                    // const oldParentX = this.box.parentContainer instanceof ContainerBox ?  this.box.parentContainer.x : 0
                    // const oldParentY = this.box.parentContainer instanceof ContainerBox ? this.box.parentContainer.y : 0
                    const xOffset = layoutOffsetBox.x - (layoutOffsetContainer.x + containerObj.x); //oldParentX //- (containerObj instanceof ContainerBox ?  containerObj.x : 0)
                    const yOffset = layoutOffsetBox.y - (layoutOffsetContainer.y + containerObj.y); //oldParentY //- (containerObj instanceof ContainerBox ?  containerObj.y : 0)
                    console.log(
                        "layoutOffsetBox",
                        layoutOffsetBox,
                        "layoutOffsetContainer",
                        layoutOffsetContainer,
                        "xOffset",
                        xOffset,
                        "yOffset",
                        yOffset,
                    );
                    this.box.parentContainer?.removeChildById(this.box.id);
                    this.box.parentContainer = containerObj;
                    this.box.x += xOffset;
                    this.box.y += yOffset;
                    containerObj.addBox(this.box);

                    if (containerObj instanceof Layout) {
                        if (this.box.cell) {
                            this.box.cell.box = null; // Empty the previous cell
                        }
                        this.box.cell = null;
                    }
                }

                console.log("closestCellObj", closestCellObj);
                if (closestCellObj) {
                    const moved = this.snapBoxToCell(this.box, closestCellObj);
                    if (!moved) {
                        // Restore box position
                        this.box.x = this.moveStart.clientX;
                        this.box.y = this.moveStart.clientY;
                    }
                }
            } else if (this.isResizing) {
                // If only resize, rebuild to restore dimensions according to properties. Object (box) is not moved in container or cell
                this.box.parentContainer.buildGrid();
            }

            if (this.box instanceof GridContainer) {
                // Rebuild grid and resize content
                // TODO: implement children boxes resizing
                this.box.buildGrid(/*true*/);
            }

            if (this.box.parentContainer != initialBoxContainer) {
                // Update the previous coordinates to keep it consistant with the new parent container
                // debugger
                this.box.updatePreviousCoordinates();
            }

            this.rebuildParentContainer(); // Rebuild from the parent container to match the parent settings
        }

        this.selectedResizePoint = "";
        this.movePosition.clientX = null;
        this.movePosition.clientY = null;
        this.isMoving = false;
        this.$emit("moved-box", null);

        // this.$emit("selected-box", null)
    }

    /**
     * Move box in the cell and adjust positions and sizes
     * @param box
     * @param cell
     * @returns true if box was moved, false otherwise
     */
    snapBoxToCell(box: Box, cell: GridCell): boolean {
        // debugger
        if (box && cell && !cell.box) {
            const padding =
                box.parentContainer instanceof GridContainer ? box.parentContainer.cellPadding : 0;
            box.x = cell.x + padding;
            box.y = cell.y + padding;
            box.width = cell.width - 2 * padding;
            box.height = cell.height - 2 * padding;
            cell.box = box;
            if (box.cell) {
                box.cell.box = null; // Empty the previous cell
            }
            box.cell = cell;
            return true;
        }
        return false;
    }

    get isResizing() {
        return [
            "left",
            "right",
            "top",
            "bottom",
            "topLeft",
            "topRight",
            "bottomLeft",
            "bottomRight",
        ].includes(this.selectedResizePoint);
    }

    /**
     * Get the closest container hovered
     * @param evt
     */
    getClosestContainer(evt: MouseEvent): GridContainer | Layout {
        if (this.box.layout) {
            let closestContainer: Element;
            const hoveredContainers = document.elementsFromPoint(evt.clientX, evt.clientY); // #
            console.log("hoveredContainers", hoveredContainers);
            for (const containerEl of hoveredContainers) {
                if (
                    ![...containerEl.classList].includes("designer-container") ||
                    containerEl.id === this.boxId
                ) {
                    // Continue if it is not a container or the box is a a container itself
                    continue;
                } else {
                    closestContainer = containerEl;
                    break;
                }
            }
            return this.box.layout.allContainersMap?.[closestContainer?.id];
        }
    }

    /**
     * Get the closest hovered grid cell in the container
     * @param evt
     * @param container
     */
    getClosestGridCell(evt: MouseEvent, container: GridContainer | Layout): GridCell | null {
        let cell: Element;
        const hoveredCells = document.elementsFromPoint(evt.clientX, evt.clientY); // #
        const cellsMap = container?.gridCellsMap;
        console.log("hoveredCells", hoveredCells);
        for (const cellEl of hoveredCells) {
            if (![...cellEl.classList].includes("grid-cell")) {
                // Continue if it is not a container or the box is a container itself
                continue;
            } else {
                const cellObj = cellsMap?.[cellEl.id];
                console.log("cellObj", cellObj, "this.boxId", this.boxId);
                if (this.box instanceof GridContainer) {
                    // A container box may have gridcells itself. In this case, we need to go further
                    console.log("Hello it's me", cellEl);
                    // debugger
                    if (cellObj?.parentContainer?.id === this.boxId) {
                        continue;
                    } else if (cellObj) {
                        cell = cellEl;
                        break;
                    }
                } else {
                    cell = cellEl;
                    break;
                }
            }
        }
        return cellsMap?.[cell?.id];
    }

    onMouseMove(evt: MouseEvent) {
        if (this.preview) {
            return;
        }
        evt.preventDefault();
        // console.log("onMouseMove evt", evt,  "id", this.selectedBoxId, evt.movementX)
        if (this.boxId && this.isMoving) {
            // const selector = ".designer-container"
            // let closestContainer: HTMLElement = evt.target?.closest(selector)
            // if (closestContainer.id === this.box.id) {
            //     // A box can also be container. In the case we have to go upper the tree
            //     if (closestContainer.parentElement) {
            //         closestContainer = closestContainer.parentElement?.closest(selector)
            //     }
            // }
            // const containerObj: ContainerBox | Layout = this.box.layout.allContainersMap?.[closestContainer?.id]
            // console.log("Box moving", evt, "this.box.parentContainer?.id", this.box.parentContainer?.id, "closestContainer", closestContainer?.id, closestContainer, "containerObj", containerObj)
            // console.log("evt.target?.parentNode", evt.target?.parentNode)

            // if (containerObj && containerObj !== this.box.parentContainer) {
            //     // debugger
            //     const oldParentX = this.box.parentContainer instanceof ContainerBox ?  this.box.parentContainer.x : 0
            //     const oldParentY = this.box.parentContainer instanceof ContainerBox ? this.box.parentContainer.y : 0
            //     const xOffset = oldParentX - (containerObj instanceof ContainerBox ?  containerObj.x : 0)
            //     const yOffset = oldParentY - (containerObj instanceof ContainerBox ?  containerObj.y : 0)
            //     this.box.parentContainer?.removeChildById(this.box.id)
            //     this.box.parentContainer = containerObj
            //     this.box.x += xOffset
            //     this.box.y += yOffset
            //     containerObj.addBox(this.box)
            //     console.log("YEPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPpp")
            // }

            // console.log("onMouseMove evt", "this.selectedResizePoint", this.selectedResizePoint, evt,  evt.movementX, "selectedBoxId", this.boxId)

            // if (["left", "top"].includes(this.selectedResizePoint)) {
            //     this.selectedBox.x += evt.movementX
            //     this.selectedBox.y += evt.movementY

            //     this.selectedBox.width -= evt.movementX
            //     this.selectedBox.height -= evt.movementY
            // } else if (["right", "bottom"].includes(this.selectedResizePoint)) {
            //     this.selectedBox.width += evt.movementX
            //     this.selectedBox.height += evt.movementY
            // }

            let [movementX, movementY] = this.moveAndReturnOffsets(evt);

            // console.log("[movementX, movementY]", [movementX, movementY])
            // const widthOnHeight = this.box.height ? this.box.width / this.box.height : 1

            switch (this.selectedResizePoint) {
                case "left":
                    this.box.x += movementX;
                    this.box.width -= movementX;
                    break;
                case "right":
                    console.log("right");
                    this.box.width += movementX;
                    break;
                case "top":
                    this.box.y += movementY;
                    this.box.height -= movementY;
                    break;
                case "bottom":
                    this.box.height += movementY;
                    break;
                case "topLeft":
                    this.box.y += movementY;
                    this.box.height -= movementY;
                    this.box.x += movementX;
                    this.box.width -= movementX;
                    break;
                case "topRight":
                    this.box.y += movementY;
                    this.box.height -= movementY;
                    this.box.width += movementX;
                    break;
                case "bottomLeft":
                    this.box.height += movementY;
                    this.box.x += movementX;
                    this.box.width -= movementX;
                    break;
                case "bottomRight":
                    this.box.height += movementY;
                    this.box.width += movementX;
                    break;
                case "box":
                    // this.onMouseMoveBox(evt)
                    this.box.x += movementX;
                    this.box.y += movementY;
            }

            this.$emit("moved-box", this.box);
        }
    }

    setMoveStart(x: number, y: number) {
        this.moveStart.clientX = x;
        this.moveStart.clientY = y;
    }

    setMovePosition(evt) {
        // console.log("setMovePosition evt", evt)
        // debugger
        if (evt) {
            this.movePosition.clientX = evt.clientX;
            this.movePosition.clientY = evt.clientY;
            // const svg = evt.target.closest("svg")
            // if (svg) {
            //     const {x, y} = DesignerService.getSVGCoordinates(svg, evt.clientX, evt.clientY)
            //     if (x == null || y == null || evt.clientX == null || evt.clientY == null) {
            //         debugger
            //         console.log("x, y, evt.clientX, evt.clientY", x, y, evt.clientX, evt.clientY)
            //     }
            //     this.movePosition.clientX = x
            //     this.movePosition.clientY = y
            // } else {
            //     this.movePosition.clientX = evt.clientX
            //     this.movePosition.clientY = evt.clientY
            // }
        }
    }

    snap = true;
    moveAndReturnOffsets(evt) {
        // debugger
        // console.log("[movementX, movementY] previous", this.movePosition, "current", {clientX: evt.clientX, clientY: evt.clientY})
        // The svg transformation-based coordinates doesn't work properly for nested svg's. Need more investigation
        // const svg = evt.target.closest("svg")
        // console.log("this.movePosition", this.movePosition)
        // if (this.movePosition.clientX == null || this.movePosition.clientY == null) {
        //     debugger
        //     console.log("x, y, evt.clientX, evt.clientY", evt.clientX, evt.clientY, evt)
        // }
        // let clientX = 0
        // let clientY = 0
        // if (svg) {
        //     const {x, y} = DesignerService.getSVGCoordinates(svg, evt.clientX, evt.clientY)
        //     clientX = x
        //     clientY = y
        // } else {
        //     clientX = evt.clientX
        //     clientY = evt.clientY
        // }

        let clientX = evt.clientX;
        let clientY = evt.clientY;

        let movementX = this.movePosition.clientX != null ? clientX - this.movePosition.clientX : 0;
        let movementY = this.movePosition.clientY != null ? clientY - this.movePosition.clientY : 0;

        const transformedMovement = this.transformMovement(evt, movementX, movementY);
        movementX = transformedMovement.movementX;
        movementY = transformedMovement.movementY;

        // let movementX = this.movePosition.clientX != null ? evt.clientX - this.movePosition.clientX : 0
        // let movementY = this.movePosition.clientY != null ? evt.clientY - this.movePosition.clientY : 0

        console.log(
            "svg svg",
            { movementX, movementY },
            { svgX: clientX, svgY: clientY },
            { clientX: evt.clientX, clientY: evt.clientY },
        );

        // if (svg) {
        //     const {x, y} = DesignerService.getSVGCoordinates(svg, movementX, movementY)
        //     console.log("svg svg", svg, {movementX, movementY}, {svgX, svgY})
        //     movementX = x
        //     movementY = y
        // }
        if (this.snap && Math.abs(movementX) < this.movementStep) {
            movementX = 0;
        } else {
            this.movePosition.clientX = clientX;
        }

        if (this.snap && Math.abs(movementY) < this.movementStep) {
            movementY = 0;
        } else {
            this.movePosition.clientY = clientY;
        }

        if (this.snap) {
            movementX = Math.round(movementX / this.movementStep) * this.movementStep;
            movementY = Math.round(movementY / this.movementStep) * this.movementStep;
        }

        // this.movePosition.clientX = evt.clientX
        // this.movePosition.clientY = evt.clientY

        return [movementX, movementY];
    }

    /**
     * Transforms the movement to account for the svg viewBox zoom in or zoom out.
     * Multiplies the movement by the the inverse zoom ratio.
     * @param evt
     * @param movementX_
     * @param movementY_
     * @returns the transformed {movementX, movementY}
     */
    transformMovement(
        evt: Event,
        movementX_: number,
        movementY_: number,
    ): { movementX: number; movementY: number } {
        const layoutSVG = (evt.target as Element).closest("svg.designer-layout") as SVGSVGElement;
        let movementX = movementX_;
        let movementY = movementY_;
        console.log("layoutSVG", layoutSVG, "movementX", movementX, "movementY", movementY);
        if (layoutSVG) {
            const viewBox = layoutSVG.viewBox.baseVal;
            const svgRect = layoutSVG.getBoundingClientRect(); // FIXME: Works but could be improved. Get the inside rect's dimensions
            // If no viewBox is set, width and height will be 0
            // const zoomX = (viewBox.width / svgRect.width) || 1
            // Only zoomY is considered because we use keepAspectRatio. And the svg fits the height but adds padding to the width to fill the 100% width
            const zoomY = viewBox.height / svgRect.height || 1;

            // const zoom = Math.min(zoomX, zoomY)

            movementX *= zoomY;
            movementY *= zoomY;

            console.log(
                "viewBox",
                viewBox,
                "layoutSVG.clientWidth",
                layoutSVG.clientWidth,
                "layoutSVG.clientHeight",
                layoutSVG.clientHeight,
                "svgRect.width",
                svgRect.width,
                "svgRect.height",
                svgRect.height,
                "zoomY",
                zoomY,
                "movementX",
                movementX,
                "movementY",
                movementY,
            );
        }
        return { movementX, movementY };
    }
}

export default toNative(BoxComponent);
</script>
<style scoped>
.resizePoint {
    display: none;
    cursor: default;
}

.box-group.selected > .box {
    stroke: skyblue;
    stroke-width: 2;
}

.box-group:hover {
    cursor: move;
}

.box-group:hover > .box {
    stroke: #f9b128;
    stroke-width: 2;
}

.box-group:hover > .resizePoint {
    display: inline;
}

.box-group:hover > .resizePoint.left,
.box-group:hover > .resizePoint.right {
    cursor: ew-resize;
}

.box-group:hover > .resizePoint.bottom,
.box-group:hover > .resizePoint.top {
    cursor: ns-resize;
}

.box-group:hover > .resizePoint:is(.topLeft, .bottomRight) {
    cursor: nwse-resize;
}

.box-group:hover > .resizePoint:is(.topRight, .bottomLeft) {
    cursor: nesw-resize;
}
</style>
